// @ts-expect-error WHY: Stylus config is not typed
import {layoutLevels} from '@pb/kit-stylus/stylus.config';

export const BASE_Z_INDEX: number = layoutLevels.level8;

/**
 * Z-index store API for managing layering of floating elements
 */
export interface ZIndexStore {
    /** Returns the next z-index value and increments the counter */
    next: () => number,
}

/**
 * Creates a z-index store that provides incrementing z-index value for floating elements to maintain proper stacking order
 */
export const createZIndexStore = (): ZIndexStore => {
    let currentZIndex = BASE_Z_INDEX;

    return {
        next: () => currentZIndex++,
    };
};

/** Singleton z-index store shared across all floating elements in the app */
export const zIndexStore = createZIndexStore();
